import path_vid from '../images/pathsearch-vid.mp4';
import sort_vid from '../images/sorting-vid.mp4';
import vidtalkie_vid from '../images/vidtalkie-vid.mp4';

const projects = [
    {
        prj_id: 1,
        video: sort_vid,
        github: 'https://github.com/alecvaluev/sort-algorithm-visualiser',
        website: 'https://sort-algorithm-visualiser.herokuapp.com',
        tools: ['ReactJs', 'ReduxJs', 'Bootstrap5'],
        completed: 2022
    },
    {
        prj_id: 2,
        video: path_vid,
        github: 'https://github.com/alecvaluev/path-search-visualizer',
        website: 'https://path-search-visualizer.vercel.app/',
        tools: ['ReactJs', 'ReduxJs', 'Bootstrap5'],
        completed: 2022
    },
    {
        prj_id: 3,
        video: vidtalkie_vid,
        github: 'https://github.com/alecvaluev/vidtalkie',
        website: 'https://vidtalkie.vercel.app',
        tools: ['ReactJs', 'TypeScript', 'NextJs', 'Tailwind CSS', 'google-oauth'],
        completed: 2022
    },
    {
        prj_id: 4,
        github: 'https://github.com/alecvaluev/Grocery-Store-Manager',
        website: '',
        tools: ['C'],
        completed: 2020
    },
    {
        prj_id: 5,
        github: 'https://github.com/alecvaluev/mathGame',
        website: '',
        tools: ['C'],
        completed: 2020
    },
    {
        prj_id: 6,
        github: 'https://github.com/alecvaluev/company-web-app',
        website: '',
        tools: ['Express', 'Mongoose', 'bcryptjs'],
        completed: 2021
    },
    {
        prj_id: 7,
        github: 'https://github.com/alecvaluev/General-Hospital-Pre-Triage-Application',
        website: '',
        tools: ['C++'],
        completed: 2021
    },
    {
        prj_id: 8,
        github: 'https://github.com/alecvaluev/assembly-line-simulation',
        website: '',
        tools: ['C++'],
        completed: 2021
    },
    {
        prj_id: 9,
        github: 'https://github.com/alecvaluev/portfolio',
        website: 'https://aleksandrvaluev.vercel.app/',
        tools: ['ReactJs', 'ReduxJs', 'Tailwind CSS'],
        completed: 2022
    }
]
export default projects;
